import FeedbackItem from "./FeedbackItem";

export default FeedbackItem;
